import { cva } from "class-variance-authority";

export const pillCva = cva(
  "inline-flex items-center justify-center gap-1.5 rounded-full font-bold select-none transition-opacity",
  {
    variants: {
      size: {
        sm: "text-xs leading-3 py-0.5 px-2",
        md: "text-sm leading-4 py-1 px-2.5",
        lg: "text-base leading-5 py-1.5 px-3",
      },
      active: {
        true: "text-primary-600 dark:text-gray-50 bg-primary-50 dark:bg-primary-600",
        false: "text-gray-800 dark:text-dark-200 bg-gray-200 dark:bg-dark-800",
      },
      disabled: {
        true: "opacity-50 cursor-not-allowed",
        false: "cursor-pointer hover:opacity-50",
      },
    },
    defaultVariants: {
      size: "md",
      active: false,
      disabled: false,
    },
  },
);

// Opt-in "outline" appearance (white pill with a thin border, grey when idle, primary tinted when selected). It is a
// separate cva instead of compound variants on pillCva because it overrides the filled base (font-bold, size
// paddings) and the project has no class merger; the filled output therefore stays untouched. The size prop does not
// apply: the outline pill has one fixed height (h-7) and text-xs.
export const pillOutlineCva = cva(
  "inline-flex items-center justify-center gap-1.5 h-7 px-2.5 rounded-full border border-solid text-xs leading-4 select-none transition-colors outline-hidden focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500",
  {
    variants: {
      active: {
        true: "font-medium text-primary-900 bg-primary-50 border-primary-200 dark:text-primary-100 dark:bg-primary-900/40 dark:border-primary-700",
        false: "font-normal text-gray-800 bg-white border-gray-300 dark:text-gray-200 dark:bg-dark-800 dark:border-dark-500",
      },
      disabled: {
        true: "opacity-50 cursor-not-allowed",
        false: "cursor-pointer",
      },
    },
    compoundVariants: [
      { active: false, disabled: false, class: "hover:border-gray-400 dark:hover:border-dark-400" },
    ],
    defaultVariants: {
      active: false,
      disabled: false,
    },
  },
);
